import { render, staticRenderFns } from "./referees.vue?vue&type=template&id=23f9203c&scoped=true&"
import script from "./referees.vue?vue&type=script&lang=js&"
export * from "./referees.vue?vue&type=script&lang=js&"
import style0 from "./referees.vue?vue&type=style&index=0&id=23f9203c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9203c",
  null
  
)

component.options.__file = "referees.vue"
export default component.exports